import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import SearchComponent from '../PricingHub/SearchComponent';

class InvoicesSearchForm extends SearchComponent {
  searchInputs = [
    {
      label: 'common:label.invoiceDate',
      name: 'invoiceDate',
      type: 'date',
      isClearable: true,
    },
    {
      label: 'common:label.dueDate',
      name: 'dueDate',
      type: 'date',
      isClearable: true,
    },
    {
      label: 'common:label.type',
      name: 'type',
      type: 'select',
      tOptions: 'selections:invoiceUnitType',
      isClearable: true,
    },
    {
      label: 'common:label.status',
      name: 'status',
      type: 'select',
      tOptions: 'selections:invoiceStatus',
      isClearable: true,
    },
  ];

  btnSpan = 'col-md-12';
}

InvoicesSearchForm.propTypes = {
  onSubmit: PropTypes.func,
  isSubmitting: PropTypes.bool,
};

InvoicesSearchForm.defaultProps = {
  isSubmitting: false,
};

export default withTranslation('common')(InvoicesSearchForm);
